
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.588 23.329c0 .31-.127.608-.352.828-.225.22-.53.343-.848.343H1.318c-.318 0-.623-.125-.847-.344a1.163 1.163 0 01-.353-.827c0-5.496 4.58-9.95 10.234-9.95s10.235 4.454 10.235 9.95h.001zm-10.236-8.78c-4.986 0-9.03 3.93-9.03 8.78 0-.003 18.068 0 18.068 0-.007-4.85-4.049-8.78-9.038-8.78zm0-2.34c-3.324 0-6.02-2.623-6.02-5.855C4.333 3.12 7.029.5 10.353.5c3.326 0 6.021 2.62 6.021 5.854 0 3.232-2.695 5.853-6.02 5.853v.001zm0-1.172c2.66 0 4.817-2.097 4.817-4.683S13.013 1.67 10.352 1.67c-2.659 0-4.815 2.097-4.815 4.683s2.156 4.682 4.815 4.682v.001z","fill":"#828282"}})])
          )
        }
      }
    